const SIGNIN_URL = process.env.AUTH_URL + '/v1/signin';

const LOGIN_HEADER = 'X-Is-Login';
const REFRESH_HEADER = 'X-Is-Refresh';

const signin = (context, user) => {
  const headers = {};
  headers[LOGIN_HEADER] = 'true';
  return context.$http.post(SIGNIN_URL, user, {headers: headers});
};
export default {
  signin,
  LOGIN_HEADER,
  REFRESH_HEADER
};



// WEBPACK FOOTER //
// ./src/brand/health/api/auth/authHttp.js